import { axiosUtils } from "../../../../network/axiosUtils";
import httpRequest from "../../../../network/httpRequest";
import { HttpResponse } from "../../../../network/types";

import { handleError } from "../../../../shared/utils";
import { CheckTokenRequest, SendPhoneNumberRequest } from "./types";

export const SendPhoneNumber = async (props: SendPhoneNumberRequest) => {
  try {
    const requestBody = {
      ...props,
      type: "message",
      kind: "sign-in-repair-shop",
    };
    const response: HttpResponse = await httpRequest({
      method: axiosUtils.POST,
      url: `/auth-tokens`,
      requestBody,
    });
    return response?.data.row;
  } catch (err) {
    const { error } = handleError(err);
    throw new Error(error.message);
  }
};
export const CheckPhoneAuth = async (props: CheckTokenRequest) => {
  try {
    const requestBody = {
      ...props,
      type: "message",
      kind: "sign-in-repair-shop",
    };
    const response: HttpResponse = await httpRequest({
      method: axiosUtils.POST,
      url: `/access-tokens`,
      requestBody,
    });
    return response?.data.row;
  } catch (err) {
    const { error } = handleError(err);
    throw new Error(error.message);
  }
};
